// extracted by mini-css-extract-plugin
export default {"homeIcon":"Breadcrumbs_homeIcon__BQH-c","arrow":"Breadcrumbs_arrow__fb1In"};